/**
 * @module components/DisplayLimit
 * @description 折线图展示限制 — 多分类维度时展示，UI 复用 TopNFieldGroup
 */
import React from 'react';
import { useIntl } from 'umi';
import ConfigCollapseCard from '@/pages/datalab/components/ConfigCollapseCard';
import TopNFieldGroup from '../common/TopNFieldGroup';
import { DEFAULT_DISPLAY_LIMIT_COUNT } from '../../utils/constants';
import { useStackedTopNDraftFields as useDisplayLimitDraftFields } from '../common/TopNFieldGroup/useStackedTopNDraftFields';

const DisplayLimit: React.FC = () => {
  const { formatMessage } = useIntl();
  const displayLimit = useDisplayLimitDraftFields(
    DEFAULT_DISPLAY_LIMIT_COUNT,
    false,
  );

  return (
    <ConfigCollapseCard
      title={formatMessage({ id: 'dbl_chart_display_limit' })}
      info={{ tipText: formatMessage({ id: 'dbl_chart_display_limit_info' }) }}
      defaultActiveIds={[]}
    >
      <TopNFieldGroup
        {...displayLimit}
        countMax={500}
        countLimitTip={formatMessage({ id: 'dbl_myAnalysis_limit_500' })}
      />
    </ConfigCollapseCard>
  );
};

export default React.memo(DisplayLimit);
